import SelectPacking from 'components/BusinessLogic/Product/SelectPacking';
import Quality from 'components/UI/Quality';
import { QualityColorEnum } from 'enums/qualityColor.enum';
import Packing from 'model/Packing';
import ProductOffer from 'model/ProductOffer';
import { GiftIcon, QualityLabel } from '../../atoms';
import {
  PackingSelectWrapper,
  QualityInfoContainer,
  QualityItem,
} from './QualityInfo.styled';

export interface QualityInfoProps {
  product: ProductOffer;
  packingSelected?: Packing;
  showPacking?: boolean;
  showGiftIcon?: boolean;
  layout?: 'row' | 'column';
  radius?: string;
  isMobileGrid?: boolean;
  onSelectPacking?: (id: number) => void;
}

const isValidQuality = (quality: string): quality is QualityColorEnum =>
  Object.values(QualityColorEnum).includes(quality as QualityColorEnum);

export function QualityInfo({
  product,
  packingSelected,
  showPacking = true,
  showGiftIcon = true,
  layout = 'row',
  radius,
  isMobileGrid = false,
  onSelectPacking,
}: QualityInfoProps) {
  const hasPackings = product.packings && product.packings.length > 0;
  const currentPacking = packingSelected || product.packings?.[0];

  const handlePackingChange = (packingId: number) => {
    if (onSelectPacking) {
      onSelectPacking(packingId);
    }
  };

  const limitText = (text: string, max: number) => {
    if (!text) return '';
    return text.length > max ? `${text.slice(0, max)}…` : text;
  };

  const formattedPackings = product.packings.map((packing) => {
    const fullPackingText = `${packing.code} - ${packing.abbrev}`;
    const maxLength = isMobileGrid ? 13 : 999;

    return {
      ...packing,
      label: limitText(fullPackingText, maxLength),
      title: fullPackingText,
    };
  });

  return (
    <QualityInfoContainer $layout={layout} className="quality-info">
      {product.quality && (
        <QualityItem $layout={layout} className="quality-item">
          <QualityLabel className="quality-label">Qualidade:</QualityLabel>
          {isValidQuality(product.quality) ? (
            <Quality quality={product.quality} radius={radius} />
          ) : (
            <span className="label">{product.quality}</span>
          )}
        </QualityItem>
      )}
      {hasPackings && showPacking && (
        <QualityItem $layout={layout} className="packaging-item">
          <QualityLabel>
            {showGiftIcon && <GiftIcon />}
            Embalagem:
          </QualityLabel>
          <PackingSelectWrapper>
            <SelectPacking
              offerId={product.offerId}
              onSelect={handlePackingChange}
              packings={formattedPackings}
              value={currentPacking?.id || product.packings[0].id}
              type="small"
            />
          </PackingSelectWrapper>
        </QualityItem>
      )}
    </QualityInfoContainer>
  );
}
